import { useState, useRef, useEffect } from "react";
import ReactQuillBase, { ReactQuillProps } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./style.scss";

const ReactQuill = ReactQuillBase as unknown as (
  props: ReactQuillProps
) => JSX.Element;

type OrbTextEditorProps = {
  placeholder?: string;
  name?: string;
  defaultValue?: string;
  value?: string;
  onChange: (content: string) => void;
} & Omit<ReactQuillProps, "onChange" | "value">;

export default function OrbTextEditor({
  placeholder,
  name,
  defaultValue,
  value,
  onChange,
  ...rest
}: OrbTextEditorProps) {
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["bold", "italic", "underline", "list", "bullet"];

  const [quillContent, setQuillContent] = useState(value || "");
  const quillRef:any = useRef<ReactQuillBase | null>(null);

  const handleQuillContentChange = (content: string) => {
    setQuillContent(content);
    onChange(content);
  };

  // 🔥 Keep toolbar button states after blur
  useEffect(() => {
    const quillInstance = (quillRef.current as any)?.getEditor?.();
    if (!quillInstance) return;

    quillInstance.on("selection-change", (range: any) => {
      if (!range) {
        // User clicked outside
        const formats = quillInstance.getFormat();
        Object.keys(formats).forEach((format) => {
          const toolbarButton = document.querySelector(
            `.ql-toolbar .ql-${format}`
          );
          if (toolbarButton && formats[format]) {
            toolbarButton.classList.add("ql-active");
          }
        });
      }
    });
  }, []);

  return (
    <div className="form-group"  ref={quillRef}>
      <ReactQuill
       
        defaultValue={defaultValue}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        className="mohave"
        value={quillContent}
        onChange={handleQuillContentChange}
        {...rest}
      />
    </div>
  );
}
